import Swiper, {
  Navigation,
  Lazy,
  Pagination,
  EffectFade,
  Scrollbar,
} from "swiper";
import GoogleMap from "../utils/map";
import PartnerSlider from "../blocks/partner-slider";

const Home = {
  init() {
    new PartnerSlider(".partners");
    Home.fancyCards();
    Home.fancyCardsSlider();
  },

  renderMap() {
    const mapEl = $("#map-wrap");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
      zoom: mapEl.data("zoom"),
    };

    GoogleMap.create(data, mapEl);
  },

  heroSlider() {
    const heroEl = $(".hero");
    if (heroEl.length) {
      new Swiper(heroEl.find(".hero-slider")[0], {
        modules: [Lazy, Pagination, EffectFade],
        slidesPerView: 1,
        loop: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        effect: "fade",
        pagination: {
          el: heroEl.find(".swiper-pagination")[0],
          bulletElement: "button",
          clickable: true,
        },
      });
    }
  },

  fancyCards() {
    const fancyBlockEl = $(".fancy-card-block");
    if (!fancyBlockEl.length || $(window).width() <= 900) {
      return;
    }

    const card = $(fancyBlockEl.find(".fancy-card"));
    const firstCard = $(fancyBlockEl).find(".fancy-card-first");
    card.mouseenter(function () {
      card.removeClass("active");
      $(this).addClass("active");
    });

    card.mouseleave(function () {
      card.removeClass("active");
      firstCard.addClass("active");
    });
  },

  fancyCardsSlider() {
    const initSlider = () => {
      const fancyBlockEl = $(".fancy-card-slider");
      if (!fancyBlockEl.length || $(window).width() > 900) {
        return;
      }

      const navPrev = fancyBlockEl.find(".swiper-button-prev")[0];
      const navNext = fancyBlockEl.find(".swiper-button-next")[0];
      const scrollbarEl = fancyBlockEl.find(".swiper-scrollbar")[0];
      const dragEl = fancyBlockEl.find(".swiper-scrollbar-drag")[0];

      new Swiper(fancyBlockEl[0], {
        modules: [Lazy, Navigation, Scrollbar],
        spaceBetween: 10,
        slidesPerView: 1.3,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 3,
        },
        scrollbar: {
          el: scrollbarEl,
          dragEl: dragEl,
          draggable: true,
          dragSize: 19,
          hide: false,
        },
        navigation: {
          prevEl: navPrev,
          nextEl: navNext,
        },
        breakpoints: {
          500: {
            spaceBetween: 20,
            slidesPerView: 1.5,
          },
        },
      });
    };

    // Initial slider setup
    initSlider();

    // Update slider on window resize
    $(window).resize(function () {
      if ($(window).width() < 900) {
        if (typeof mySwiper !== "undefined" && mySwiper !== null) {
          mySwiper.destroy(true, true);
        }
        initSlider();
      }
    });
  },

  testimontialsSlider() {
    const sliderDom = $(".testi-slider");
    if (sliderDom.length) {
      const navPrev = sliderDom
        .closest(".testimonials")
        .find(".swiper-button-prev");
      const navNext = sliderDom
        .closest(".testimonials")
        .find(".swiper-button-next");

      new Swiper(sliderDom[0], {
        modules: [Lazy, Navigation, Pagination],
        loop: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        pagination: {
          el: sliderDom.find(".swiper-pagination"),
          bulletElement: "button",
          clickable: true,
        },
      });

      $(document).on("click", ".testi-slide .btn-more", (e) => {
        const current = $(e.target);
        const short = current
          .closest(".testi-slide")
          .find(".testi-slide__desc--short");

        const full = current
          .closest(".testi-slide")
          .find(".testi-slide__desc--full");

        $(short).toggleClass("hidden");
        $(full).toggleClass("hidden");

        if (!$(short).hasClass("hidden")) {
          current.text(current.attr("data-more"));
        } else {
          current.text(current.attr("data-less"));
        }
      });
    }
  },

  gridItemsAdvancedSlider() {
    const cardsSwiperEl = $(".services-advanced");
    if (!cardsSwiperEl.length) {
      return;
    }

    if (cardsSwiperEl.length) {
      new Swiper(cardsSwiperEl.find(".swiper")[0], {
        modules: [Lazy, Pagination],
        slidesPerView: "auto",
        spaceBetween: 20,
        pagination: {
          el: cardsSwiperEl.find(".swiper-pagination"),
          type: "bullets",
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
      });
    }
  },
};

export default Home;
